import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";


export class ReminderModel extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ReminderModel, v) : SKIP;
            },
            (v) => {
                return deserialize(ReminderModel, v);
            }
        );
    }

    constructor() {
        super();

        this._key = "";
        this._name = "";
        this._time = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get time() {
        return this._time;
    }

    set time(value) {
        this._time = value;
    }

    valid() {
        if (!this.key || this.key === "") {
            return false;
        }

        if (!Number.isInteger(this.time) || this.time <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return this.time <= 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ReminderModel());
        } else if (target instanceof ReminderModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ReminderModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _time: alias("time", Schema.primitive())
});